import IconActivity from './activity.svg';
import IconAddUser from './add-user.svg';
import IconArrowLeft from './arrow-left.svg';
import IconBuilding from './building.svg';
import IconCamera from './camera.svg';
import IconCameraStep from './camera-step.svg';
import IconClock from './clock.svg';
import IconComputing from './computing.svg';
import IconEdit02 from './edit-02.svg';
import IconFlagAR from './flag-ar.svg';
import IconFlagEN from './flag-en.svg';
import IconGalleryAdd from './gallery-add.svg';
import IconLanguageSquare from './language-square.svg';
import IconLocation from './location.svg';
import IconLocationStep from './location-step.svg';
import IconLock from './lock.svg';
import IconLogout from './logout.svg';
import IconMaximizeCircle from './maximize-circle.svg';
import IconPentagon from './pentagon.svg';
import IconPerson2 from './person-2.svg';
import IconPresentationChart from './presentation-chart.svg';
import IconProfile2User from './profile-2user.svg';
import IconRectangle from './rectangle.svg';
import IconRefresh2 from './refresh-2.svg';
import IconSecurityUserTime from './security-user-time.svg';
import IconSetting2 from './setting-2.svg';
import IconSettingsStep from './settings-step.svg';
import IconShieldLock1 from './shield-lock-1.svg';
import IconSmsEdit from './sms-edit.svg';
import IconStar from './star.svg';
import IconStarFilled from './star-filled.svg';
import IconSunMoon from './sun-moon.svg';
import IconTrash from './trash.svg';
import IconTriangle from './triangle.svg';
import IconUser from './user.svg';
import IconUserGender from './user-gender.svg';
import IconUserSquare from './user-square.svg';
import IconUserTime from './user-time.svg';
import IconWidgetStep from './widget-step.svg';

export {
  IconActivity,
  IconAddUser,
  IconArrowLeft,
  IconBuilding,
  IconCamera,
  IconCameraStep,
  IconClock,
  IconComputing,
  IconEdit02,
  IconFlagAR,
  IconFlagEN,
  IconGalleryAdd,
  IconLanguageSquare,
  IconLocation,
  IconLocationStep,
  IconLock,
  IconLogout,
  IconMaximizeCircle,
  IconPentagon,
  IconPerson2,
  IconPresentationChart,
  IconProfile2User,
  IconRectangle,
  IconRefresh2,
  IconSecurityUserTime,
  IconSetting2,
  IconSettingsStep,
  IconShieldLock1,
  IconSmsEdit,
  IconStar,
  IconStarFilled,
  IconSunMoon,
  IconTrash,
  IconTriangle,
  IconUser,
  IconUserGender,
  IconUserSquare,
  IconUserTime,
  IconWidgetStep,
};
